import WebshareApi from "..";
import { NotificationObjectType } from "@/types/NotificationTypes";

export const dismissNotification = (id: number) =>
  WebshareApi.post<NotificationObjectType>(`/notification/${id}/dismiss/`);

export const restoreNotification = (id: number) =>
  WebshareApi.post<NotificationObjectType>(`/notification/${id}/restore/`);
